import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const TwitterIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}
            <path
                d="M16.224 14.1522L10.3108 5.8782H7.15696L21.6737 26.1958H24.8275L17.1421 15.4414L16.224 14.1522Z"
                fill="currentColor"
            />
            <path
                d="M29.3233 0H2.67667C1.19833 0 0 1.19833 0 2.67667V29.3233C0 30.8017 1.19833 32 2.67667 32H29.3233C30.8017 32 32 30.8017 32 29.3233V2.67667C32 1.19833 30.8017 0 29.3233 0ZM20.706 27.6364L14.3604 18.5993L6.41664 27.6364H4.36364L13.45 17.3023L4.36364 4.36364H11.294L17.3015 12.9192L24.8285 4.36364H26.8814L18.2167 14.2191L27.6364 27.6364H20.706Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default TwitterIcon;
